import React from 'react';
import { TopBanner } from './components/TopBanner';
import { HeroSection } from './components/HeroSection';
import { BenefitsSection } from './components/BenefitsSection';
import { TransformationSection } from './components/TransformationSection';
import { BonusSection } from './components/BonusSection';
import { ValueStackSection } from './components/ValueStackSection';
import { UpsellSection } from './components/UpsellSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { CheckoutSection } from './components/CheckoutSection';
import { EmotionalClose } from './components/EmotionalClose';
import { StickyCTA } from './components/StickyCTA';
export function App() {
  return <div className="min-h-screen bg-beige font-sans text-navy selection:bg-gold/30 selection:text-navy" data-id="element-0">
      <TopBanner data-id="element-1" />
      <HeroSection data-id="element-2" />
      <BenefitsSection data-id="element-3" />
      <TransformationSection data-id="element-4" />
      <BonusSection data-id="element-5" />
      <ValueStackSection data-id="element-6" />
      <UpsellSection data-id="element-7" />
      <TestimonialsSection data-id="element-8" />
      <GuaranteeSection data-id="element-9" />
      <EmotionalClose data-id="element-10" />
      <CheckoutSection data-id="element-11" />
      <FAQSection data-id="element-12" />

      <footer className="w-full py-6 text-center text-sm text-slate-light border-t border-beige-dark/30 bg-beige" data-id="element-13">
        <p data-id="element-14">© 2025 Volvé a Calmar tu Mente. Todos los derechos reservados.</p>
      </footer>

      <StickyCTA data-id="element-15" />
    </div>;
}